/*
* Copyright 2026 Tecnalia, Basque Research & Technology Alliance (BRTA)
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*    http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*
*  SPDX-License-Identifier: Apache-2.0
*/

import { AppConfigService } from '../app-config/app-config.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { EMPTY, expand, map, Observable, reduce } from 'rxjs';
import { Catalog } from '../../models/catalog-dto';
import { Injectable } from '@angular/core';

@Injectable({
  	providedIn: 'root'
})

export class HttpGetCatalogService {

    public readonly URL: string;
	private readonly pageSize = 50;

	constructor(
		private http: HttpClient,
        private configSvc: AppConfigService
	) {
        this.URL = this.configSvc.settings.apiUrl + 'v1alpha/catalog/query';
    }

	public obtain$(): Observable<Catalog[]> {
		return this.obtainPage$(0).pipe(
			expand(({ catalogs, offset }) => catalogs.length === this.pageSize
				? this.obtainPage$(offset + this.pageSize)
				: EMPTY
			),
			map(({ catalogs }) => catalogs),
			reduce((allCatalogs, catalogs) => [...allCatalogs, ...catalogs], [] as Catalog[])
		);
	}

	private obtainPage$(offset: number): Observable<{ catalogs: Catalog[]; offset: number }> {

		const body = {
			"@context": {
				"@vocab": "https://w3id.org/edc/v0.0.1/ns/"
			},
			"@type": "QuerySpec",
			"offset": offset,
			"limit": this.pageSize
		};

		const headers = new HttpHeaders({
			'x-api-key': this.configSvc.settings.catalogAPIKey,
			'Content-Type': 'application/json'
		});

		return this.http.post<Catalog[] | Catalog>(
			this.URL,
			body,
			{ headers }
		).pipe(
			map((response: Catalog[] | Catalog) => ({
				catalogs: Array.isArray(response) ? response : [response],
				offset
			}))
		);

	}

}